import React from "react";
import ReactECharts from "echarts-for-react";
import { Spin, Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface TaskPlannedVsActualKPIChartProps {
  loading: boolean;
  chartData:
    | {
        planned: number;
        actual: number;
      }
    | null
    | undefined
    | {};
}

const TaskPlannedVsActualKPIChart: React.FC<
  TaskPlannedVsActualKPIChartProps
> = ({ loading, chartData }) => {
  console.log("chartData", chartData);

  const isValidChartData = (() => {
    if (!chartData || typeof chartData !== "object") return false;
    if (Object.keys(chartData).length === 0) return false;

    const { planned = 0, actual = 0 } = chartData as any;
    return !(planned === 0 && actual === 0);
  })();

  const getChartOptions = () => {
    // if (!chartData) return {};
    if (!isValidChartData) return {};

    const plannedValue = (chartData as any).planned || 0;
    const actualValue = (chartData as any).actual || 0;

    const displayPlanned = Math.abs(plannedValue);
    const displayActual = Math.abs(actualValue);
    const remaining = Math.max(displayPlanned - displayActual, 0);

    return {
      animationDuration: 600,
      grid: {
        top: 30,
        bottom: 50,
        left: 50,
        right: 30,
      },
      xAxis: {
        type: "category",
        data: ["Planned Hours", "Actual Hours"],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          show: true,
          fontSize: 12,
          fontWeight: 500,
          align: "center",
          color: "#000",
          lineHeight: 20,
        },
        splitLine: { show: false },
      },
      yAxis: {
        type: "value",
        name: "Hours",
        nameGap: 20,
        nameTextStyle: {
          fontSize: 12,
          fontWeight: 500,
        },
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          fontSize: 12,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#f0f0f0",
          },
        },
      },
      series: [
        {
          name: "Planned",
          type: "bar",
          barWidth: 40,
          data: [displayPlanned, 0],
          itemStyle: {
            color: "#5b9bd5",
          },
          label: {
            show: displayPlanned !== 0,
            position: "top",
            formatter: (params: any) =>
              params.value !== 0
                ? `${Math.abs(params.value).toFixed(2)} hrs`
                : "",
            fontSize: 12,
            color: "#333",
            fontWeight: 500,
          },
        },
        {
          name: "Actual",
          type: "bar",
          barWidth: 40,
          data: [0, displayActual],
          itemStyle: {
            color: "#70ad47",
          },
          label: {
            show: displayActual !== 0,
            position: "top",
            formatter: (params: any) =>
              params.value !== 0
                ? `${Math.abs(params.value).toFixed(2)} hrs`
                : "",
            fontSize: 12,
            color: "#333",
            fontWeight: 500,
          },
        },
        {
          name: "Remaining",
          type: "line",
          data: [null, remaining],
          lineStyle: {
            type: "dotted",
            width: 2,
            color: "#f5222d",
          },
          symbol: "none",
          tooltip: {
            show: false,
          },
          z: 10,
        },
      ],
      graphic: {
        elements: [
          {
            type: "text",
            left: "center",
            bottom: 10,
            style: {
              text: `Remaining: ${remaining.toFixed(2)} hrs`,
              fill: "#f5222d",
              font: "bold 13px sans-serif",
            },
          },
        ],
      },
    };
  };

  if (loading) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  // if (!chartData || (chartData.planned === 0 && chartData.actual === 0)) {
  if (!isValidChartData) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Empty description="No data available" />
        <div style={{ marginTop: 10, color: "#999", fontSize: 12 }}>
          Planned: 0 hrs | Actual: 0 hrs
        </div>
      </div>
    );
  }

  return (
    <ReactECharts
      style={{ height: 260, width: "100%" }}
      option={getChartOptions()}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default TaskPlannedVsActualKPIChart;
